<template>
  <div class="big-box">

    <div class="mainline">
      <span class="primary">{{ $rulesets[ruleset].getArmorClass(ac) }}</span>
    </div>

    <label  @click="toggleState = !toggleState" :for="'armor-class-' + this._uid" class="has-toggle">
      AC
    </label>

    <span  v-if="ruleset === 'PFRPG'">
    <toggle :id="'armor-class-' + this._uid" v-model="toggleState"></toggle>
    <div v-if="toggleState" class="text-center">
      <div class="row tight">
        <div class="col">
          <under-text>
            <div slot="underline">
              {{ $rulesets[ruleset].getArmorClassTouch(ac) }}
            </div>
            Touch
          </under-text>
        </div>
        <div class="col-12 col-sm-7">
          <under-text>
            <div slot="underline">
              {{ $rulesets[ruleset].getArmorClassFlatFooted(ac) }}
            </div>
            Flat-F
          </under-text>
        </div>
      </div>
    </div>
  </span>

  </div>
</template>
<script>
import { mapState } from "vuex";
import UnderText from "../shared/_UnderText.vue";
import Toggle from "../shared/_Toggle.vue";

export default {
  name: "big-boxes-armor-class",
  components: {
    UnderText,
    Toggle
  },
  data() {
    return {
      toggleState: false
    };
  },
  computed: {
    ...mapState({
      ruleset: state => state.characters.current.ruleset,
      experience: state => state.characters.current.core.experience,
      armorClass: state => state.characters.current.defense.armorClass,
      attributes: state => state.characters.current.attributes,
      size: state => state.characters.current.core.size
    }),
    dexterity() {
      return this.attributes.find(x => x.name === "dexterity");
    },
    ac() {
      let obj = {
        experience: this.experience,
        armorClass: this.armorClass,
        dexterity: this.dexterity,
        size: this.size
      };
      return obj;
    }
  }
};
</script>
